query TagSelection {
  tags(orderBy: BADGE_NAME_ASC) {
    totalCount
    nodes {
      id
      badgeName
      badgeColor
    }
  }
}
